/* Установщик «Фотосессия»: объект в window на том месте порядка скриптов, где стоял assets/bot-shoot.js.
   В серверном режиме движок шаблона получает сервер экрана (shoot-server.ts) и экран shoot встаёт в реестр движков студии;
   выбирает его только список экранов сборки (engine-kit/engine-default.json — пустой до коммита переключения, инвариант I4). */
import { isServerMode } from '../../platform/server-mode';
import { createShoot } from './engine';
import { createShootServer, registerShootEngine } from './shoot-server';

export function installShoot() {
  const server = isServerMode();
  createShoot(server ? createShootServer : null);
  if (server) registerShootEngine();
}
